// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"iw_a bhj_je","CommentListPlaceholder--Legacy":"iw_b bhj_qh bhj_vk"};